// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__TrTnt","button":"styles_button__vA67M"};